import { css } from "@linaria/core";

export const wrapper = css`
  padding: 30px 45px 20px;

  box-sizing: border-box;
  height: 100%;

  background-color: rgb(247 247 247);
  border-radius: 4px;

  overflow: hidden;

  display: flex;
  flex-direction: column;

  line-height: 0;
  color: rgba(9 11 25 / 0.1);

  @media (max-width: 767px) {
    box-sizing: border-box;
    width: 100%;

    flex-direction: row;
    align-items: flex-start;
  }
`;

export const icon = css`
  margin: 0 auto;
  margin-bottom: 30px;

  max-width: 100%;
  width: 85px;

  display: block;

  fill: currentColor;
`;

export const headingBar = css`
  margin-bottom: 15px;

  height: 12px;
  width: 100%;

  background: currentColor;

  display: block;
`;

export const descriptionBar = css`
  margin-bottom: 8px;

  height: 7px;
  width: 100%;

  background: currentColor;

  display: block;

  &.last {
    width: 70%;
  }
`;

export const chevron = css`
  margin-top: 10px;
  margin-right: -25px;
  margin-left: auto;

  height: 34px;
  width: 34px;

  background: currentColor;
  border-radius: 50%;

  display: grid;

  place-items: center;

  color: rgba(255 255 255);
`;
